// Replaced at build time by build.mjs.
declare const process: { env: Record<string, string> };

export const IDENTITY_API_URL = process.env.IDENTITY_API_URL;
export const SUPABASE_URL = process.env.SUPABASE_URL;
export const SUPABASE_PUBLISHABLE_KEY = process.env.SUPABASE_PUBLISHABLE_KEY;
